import Cookies from 'js-cookie';
import { createSelector } from 'reselect';

import {
  __getCommonData,
  getBodyData,
  getHeaderData,
  getCommonSettingsData,
} from '../../selectors';

/** @private, do not use this method in components, use lower level fields instead */
export const __getCommonSettings = (state) => __getCommonData(state).settings;

export const getStoreCookiePath = (state) => __getCommonSettings(state).cookiePath;
export const getCommonPageLoaded = (state) => __getCommonSettings(state).pageLoaded;
export const getRequestVerificationToken = (state) =>
  __getCommonSettings(state).requestVerificationToken;

export const getCookieObserverHash = (state) => state.cookieHash;

/**
 * Selector wrapper for cookies to prevent issues with server render,
 * will return undefined for all cookies until page is loaded
 *
 * !!! IMPORTANT: All the cookie selectors must be using this as a wrapper in the following format:
 * With redux:
 * createSelector(
 *   getValueOfCookie(customCookieNameSelector),
 *   ...otherSelectors,
 *   (cookieValue, ...otherValues) => ...
 * );
 *
 * Without reselect:
 * const cookieValue = getValueOfCookie(customCookieNameSelector)(state);
 */
export const getValueOfCookie = (cookieNameSelector) =>
  createSelector(
    cookieNameSelector,
    getCookieObserverHash,
    getCommonPageLoaded,
    (cookieName, pageLoaded) => {
      console.assert(cookieName, 'Attempting to get value of cookie without passing a proper name');
      return pageLoaded && cookieName ? Cookies.get(cookieName) : undefined;
    },
  );

/** Thats for '_ga' cookie, probably, some other day refactor RegExp */
export const getCookie = (name) => {
  const matchReg = new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'); //eslint-disable-line
  const matches = document.cookie.match(matchReg);
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
 * Current Region data
 */
const getCurrentRegionData = (state) => getHeaderData(state).currentRegion || {};
const getUserRegionData = (state) =>
  getCurrentRegionData(state).userRegion || getCurrentRegionData(state);
export const getCurrentRegionId = (state) => getUserRegionData(state).id || null;
export const getCurrentRegionName = (state) => getUserRegionData(state).title || null;
export const getCurrentRegionCode = (state) => getUserRegionData(state).code || '';

/** this is the only way to get federalRegion */
const getPageSeoData = (state) => (getBodyData(state).seo || {}).dataLayerObject || {};
export const getCurrentFederalRegionName = (state) => getPageSeoData(state).federalRegionName;

export const getIsFavoritesActive = (state) => getCommonSettingsData(state)?.isFavoritesActive;
export const getisCompareActive = (state) => getCommonSettingsData(state)?.isCompareActive;
export const isFlocktoryEnabledSelector = (state) =>
  getCommonSettingsData(state).isFlocktoryEnabled;
export const isTradeInEnabled = (state) => Boolean(getCommonSettingsData(state).isShowTradein);
export const selectIsBasketRedirectEnabled = (state) =>
  Boolean(getCommonSettingsData(state).isBasketRedirectEnabled);
export const selectDisplayShortName = (state) => getCommonSettingsData(state).displayShortName;
export const selectIsCJBundle = (state) => getCommonSettingsData(state).cjBundle;
export const selectMetaSettings = (state) => getCommonSettingsData(state).meta;
export const selectRequestUrl = (state) => selectMetaSettings(state)?.requestUrl || '';
export const getIsDigineticaRecommendsAvailable = (state) =>
  getCommonSettingsData(state)?.digineticaToggle;
export const selectIsSemanticUrlFilters = (state) =>
  getCommonSettingsData(state)?.isSemanticURLfilters;
